import { PayloadAction } from '@reduxjs/toolkit';
import { createAppSlice } from 'app/createAppSlice'
import { doPost } from 'helpers/api_helper';
import { User } from 'helpers/types';
import { socket } from 'helpers/websocket';

export interface UserSliceState {
  user: User | null
  wallet: any
  token: string
  ownedAssets: string[]
}

const initialState: UserSliceState = {
  user: null,
  wallet: {},
  token: "",
  ownedAssets: []
}

export const loginSlice = createAppSlice({
  name: "login",
  initialState,
  reducers: create => ({
    login: create.asyncThunk(
      async (sig: any) => {
        const res = await doPost("/api/login", sig, {})

        console.log(res.data);

        // Preserve ownedAssets from localStorage if already set
        const authUserString = localStorage.getItem("authUser");
        let ownedAssets: string[] = [];
        if (authUserString) {
          try {
            const authUser = JSON.parse(authUserString);
            ownedAssets = authUser.wallet?.ownedAssets || [];
          } catch (e) {}
        }

        // Merge server response with our ownedAssets
        const mergedData = {
          ...res.data,
          wallet: {
            ...res.data.wallet,
            ownedAssets
          }
        };

        localStorage.setItem("authUser", JSON.stringify(mergedData));

        return mergedData
      },
      {
        pending: state => {
        },
        fulfilled: (state, action) => {
          state.user = action.payload.user || {}
          state.wallet = action.payload.wallet || {}
          state.token = action.payload.token || ""
        },
        rejected: state => {
        },
      },
    ),
    logout: create.reducer(state => {
      console.log("reducer logout")
      localStorage.removeItem("authUser")
      state.user = null
      state.wallet = {}
      state.token = ""
      state.ownedAssets = []
      socket.disconnect()
    }),

    setLoginData: create.reducer((state, action: PayloadAction<UserSliceState>) => {
      state.user = action.payload.user
      state.wallet = action.payload.wallet || {}
      state.token = action.payload.token || ""
      state.ownedAssets = action.payload.ownedAssets || []
    }),

    setOwnedAssets: create.reducer((state, action: PayloadAction<string[]>) => {
      state.ownedAssets = action.payload
      const authUserString = localStorage.getItem("authUser");
      if (authUserString) {
        try {
          const authUser = JSON.parse(authUserString);
          authUser.wallet = authUser.wallet || {};
          authUser.wallet.ownedAssets = action.payload;
          localStorage.setItem("authUser", JSON.stringify(authUser));
        } catch (e) {
          console.error("Error saving ownedAssets to localStorage:", e);
        }
      }
    }),

    updateUser: create.reducer((state, action: PayloadAction<User>) => {
      state.user = action.payload;
    }),
  }),

  selectors: {
    selectUser: s => s.user,
    selectWallet: s => s.wallet,
    selectOwnedAssets: s => s.ownedAssets,
  },

})

export const { login, logout, setLoginData, setOwnedAssets, updateUser } = loginSlice.actions

export const { selectUser, selectWallet, selectOwnedAssets } = loginSlice.selectors

export default loginSlice.reducer
